import React from 'react'
import { Typography } from 'antd'
import { useHistory } from 'react-router-dom'
import { formatDateTime, termDisplay } from './terminalModel'

const { Text } = Typography

// 应用项目接入状态文案（后端 project.status）。
const STATUS_META = {
  approved: { label: '已创建', tone: 'muted' },
  provisioning: { label: '接入中', tone: 'warn' },
  ready: { label: '已就绪', tone: 'ok' },
  failed: { label: '接入失败', tone: 'danger' },
  deleting: { label: '删除中', tone: 'danger' },
  disabled: { label: '已停用', tone: 'muted' },
  deleted: { label: '已删除', tone: 'muted' }
}

const DEPLOYMENT_MODE_TEXT = { server: '服务器部署', local: '仅本地运行' }
const BUSINESS_SUBJECT_TEXT = { lechun: '乐纯', superbody: '超体' }
const MYSQL_STATUS_TEXT = { created: '已创建', existing: '已绑定', failed: '配置失败' }

const PROFILES_VIBE_PAGE = '/portal/profile?tab=vibeprojects'

/**
 * 应用项目（Vibe 应用）概览（P6）。
 * 数据来自后端 P6 扩展后的 /aic/dashboard/datasets/{projectId} application 分支；
 * 字段缺失时统一显示 —，不伪造数据。个人中心「Vibe 项目」tab 保留期间提供跳转入口。
 */
export default function ApplicationOverview ({ row, detail }) {
  const history = useHistory()
  const source = detail || {}
  const statusKey = String(source.status || '').toLowerCase()
  const statusMeta = STATUS_META[statusKey] || { label: termDisplay(source.status), tone: 'muted' }
  const deploymentMode = source.deploymentMode === 'local' ? 'local' : 'server'
  const ownerText = source.ownerUserNick || source.ownerUserName || (row && row.owner)
  const description = source.description || source.dataSummary || (row && row.anomalyReason)
  const mysqlStatusText = MYSQL_STATUS_TEXT[String(source.mysqlDatabaseStatus || '').toLowerCase()]

  return <div className="term-panel term-app">
    <dl className="term-kv">
      <dt>状态</dt>
      <dd><span className={`term-app-status term-app-tone-${statusMeta.tone}`}>{statusMeta.label}</span></dd>
      <dt>项目类型</dt><dd>Vibe 应用 · {DEPLOYMENT_MODE_TEXT[deploymentMode]}</dd>
      <dt>主体</dt><dd>{BUSINESS_SUBJECT_TEXT[source.businessSubject] || termDisplay(source.businessSubject)}</dd>
      <dt>访问地址</dt>
      <dd>
        {source.publicUrl
          ? <Text className="term-mono" copyable={{ text: source.publicUrl }}>{source.publicUrl}</Text>
          : <span className="term-muted">未配置</span>}
        {source.basePath ? <span className="term-app-sub"> · basePath {source.basePath}</span> : null}
      </dd>
      <dt>数据库</dt>
      <dd>
        {source.mysqlDatabaseName
          ? <React.Fragment>
            <span className="term-mono">{source.mysqlDatabaseName}</span>
            {mysqlStatusText ? <span className="term-app-sub"> · {mysqlStatusText}</span> : null}
          </React.Fragment>
          : <span className="term-muted">未配置</span>}
      </dd>
      <dt>代码仓库</dt>
      <dd>
        {source.gitlabWebUrl
          ? <Text className="term-mono" copyable={{ text: source.gitlabWebUrl }}>{source.gitlabWebUrl}</Text>
          : <span className="term-muted">未配置</span>}
      </dd>
      <dt>登记人</dt><dd>{termDisplay(ownerText)}</dd>
      <dt>数据 Owner</dt><dd>{termDisplay(source.dataOwner)}</dd>
      <dt>创建时间</dt><dd>{formatDateTime(source.createTime)}</dd>
      <dt>最近接入</dt><dd>{formatDateTime(source.lastProvisionedAt)}</dd>
      <dt>说明</dt><dd>{termDisplay(description)}</dd>
    </dl>
    {source.provisionError
      ? <div className="term-app-error">
        <div className="term-ops-label">接入失败原因</div>
        <pre className="term-ops-pre">{source.provisionError}</pre>
      </div>
      : null}
    {source.mysqlDatabaseError
      ? <div className="term-app-error">
        <div className="term-ops-label">数据库配置失败原因</div>
        <pre className="term-ops-pre">{source.mysqlDatabaseError}</pre>
      </div>
      : null}
    <div className="term-panel-actions">
      <button type="button" className="term-link" onClick={() => history.push(PROFILES_VIBE_PAGE)}>去个人中心管理</button>
      <span className="term-muted">看板内可查看状态并执行操作；个人中心「Vibe 项目」tab 暂时保留。</span>
    </div>
  </div>
}
